import { CategoryCarouselItem, CourseCarouselItem } from 'types/CourseTypes';
import { H4 } from 'components/01-atoms/Heading';
import { CourseCard } from 'components/02-molecules/CourseCard';
import { routes } from 'lib/routes';
import { PLACEHOLDER_IMAGE, FASTLY_PARAMS } from 'lib/constants';

type Props = {
  courses: CategoryCarouselItem[] | CourseCarouselItem[];
};

export const CoursesSection = ({ courses }: Props) => (
  <section className="container mx-auto">
    <H4 headingText="Courses and Lessons" className="py-9 narrow-x:pt-10" />
    <div className="grid grid-cols-2 gap-x-6 gap-y-10 narrow-x:grid-cols-4 narrow-x:gap-x-7 narrow-x:gap-y-12">
      {courses.map((course) => (
        <CourseCard
          key={course.id}
          imageSrc={
            course.heroImage
              ? `${course.heroImage}?crop=16:9&width=450&${FASTLY_PARAMS}`
              : PLACEHOLDER_IMAGE
          }
          imageAlt={course.title}
          heading={course.title}
          description={course.excerpt || course.overview?.description}
          href={
            course.isStandalone
              ? routes.standaloneLesson(course.name)
              : routes.courseIntroduction(course.name)
          }
          instructor={course.instructors?.[0]?.name}
          hoverOverlayText={`Go to ${
            course.isStandalone ? 'Lesson' : 'Course'
          }`}
        />
      ))}
    </div>
  </section>
);
